import { FC, SVGProps } from 'react'

export const Reply: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M9.53033 3.46967C9.82322 3.76256 9.82322 4.23744 9.53033 4.53033L4.81066 9.25H13C15.3206 9.25 17.5462 10.1719 19.1872 11.8128C20.8281 13.4538 21.75 15.6794 21.75 18V20C21.75 20.4142 21.4142 20.75 21 20.75C20.5858 20.75 20.25 20.4142 20.25 20V18C20.25 16.0772 19.4862 14.2331 18.1265 12.8735C16.7669 11.5138 14.9228 10.75 13 10.75H4.81066L9.53033 15.4697C9.82322 15.7626 9.82322 16.2374 9.53033 16.5303C9.23744 16.8232 8.76256 16.8232 8.46967 16.5303L2.46967 10.5303C2.17678 10.2374 2.17678 9.76256 2.46967 9.46967L8.46967 3.46967C8.76256 3.17678 9.23744 3.17678 9.53033 3.46967Z"
			fill="currentColor"
		/>
	</svg>
)
